import { createTheme } from '@mui/material';

export const theme = createTheme({
    components: {
        MuiLink: {
            defaultProps: {
                underline: 'hover',
            },
            styleOverrides: {
                underlineHover: {
                    '&:hover': {
                        color: '#BBD0E0',
                    },
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#73ADD3',
            contrastText: '#fff',
        },
        secondary: {
            main: '#BBD0E0',
        },
        background: {
            default: '#fff',
        },
    },
});
